import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconCurrencyDollar: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-outlined-radius-3-stroke-1.5-IconCurrencyDollar"><Path d="M5.75 17.6374C8.13095 22.1337 18.25 21.7142 18.25 16.6672C18.25 10.7882 6.27083 13.8148 6.27083 7.30303C6.27083 2.72429 14.3217 1.95535 17.5 5.35201" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/><Path d="M12 22.75V1.25" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/></CentralIconBase>;
});

export default IconCurrencyDollar;
